export default function isValidCRM(crm) {
    var numbers = crm.replace(/[^0-9]/g,'');
    return parseInt(numbers) > 0;
}
